import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6de0bbe")

_pushScopeId("data-v-a6de0bbe")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_4 = { class: "detail-wrapper" }
const _hoisted_5 = { class: "title-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
                return (_openBlock(), _createBlock("div", {
                  class: "cover-item",
                  key: k,
                  onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
                }, [
                  _createVNode("img", {
                    src: i.cover
                  }, null, 8, ["src"])
                ], 8, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].title), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].imgs, (i, k) => {
                  return (_openBlock(), _createBlock(_component_ImgContainer, {
                    class: "detail-image",
                    key: k,
                    src: i
                  }, null, 8, ["src"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack,
              showBuy: true,
              onBuy: _ctx.buyAction
            }, null, 8, ["onAction", "onBuy"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})